export default __webpack_public_path__ + "static/media/rocket_anim_124.63d10aee.png";